const isOutsideBox = (dialog, { clientX, clientY }) => {
  const { top, right, bottom, left } = dialog.getBoundingClientRect();

  return clientY < top || clientY > bottom || clientX < left || clientX > right;
};

// A click targets the common ancestor of the press and the release, so the dialog itself is
// also reported for a selection released outside the box and for its own scrollbar. Requiring
// the press to land on the backdrop too rules both out.
export default function isBackdropClick(dialog, clickEvent, pressEvent) {
  return (
    clickEvent.target === dialog &&
    pressEvent?.target === dialog &&
    isOutsideBox(dialog, pressEvent) &&
    isOutsideBox(dialog, clickEvent)
  );
}
